import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { LabelWithIconInfo } from '../../../../common/LabelWithIconInfo'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { Panel } from '../../../../common/panel'
import { panelTypes } from '../../../../common/panel/constants'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { BusinessYearsTable } from './BusinessYearsTable'
import { BusinessYearsPieChart } from './pieChart'
import { resetStore, selectData, selectIsLoading } from './store/slice'
import { exportBusinessYears, getBusinessYearsTable } from './store/thunk'
import { Translate } from 'react-redux-i18n'
import { COMPANY_TYPES } from '../../../../utils/common'

export const BusinessYears = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const data = useSelector(selectData)
  const isLoading = useSelector(selectIsLoading)
  const locale = useSelector((state) => state.i18n.locale)
  const { organizationShortName, organizationName, taxCode, companyType } =
    useSelector(selectCompanyInfo)
  const label = UseI18n('industryOverview.businessYears.BUSINESS_BY_YEARS')

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(
      getBusinessYearsTable({
        OrganizationId: params.organizationId,
      }),
    )
  }, [locale, params.organizationId])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="positionRelative h100">
          <Loading />
        </div>
      )
    }

    if (!Object.keys(data).length) {
      return <Notification />
    }

    return (
      <div className="flexColumn h100">
        <div id="businessYearsPieChartId">
          <BusinessYearsPieChart />
        </div>

        <div className="flex1">
          <BusinessYearsTable />
        </div>
      </div>
    )
  }

  return (
    <Panel
      id="businessYearsId"
      height={364}
      renderLabel={() => (
        <LabelWithIconInfo
          label={'industryOverview.businessYears.BUSINESS_BY_YEARS'}
          renderToolTipContent={() => (
            <Translate
              value={
                companyType === COMPANY_TYPES.BANK
                  ? 'industryOverview.businessYears.BANK_TOOLTIP'
                  : 'industryOverview.businessYears.TOOLTIP'
              }
            />
          )}
        />
      )}
      type={panelTypes.HALF_SIZE}
      downloadJpgParams={{
        disabled: !Object.keys(data).length,
        arrName: [
          label,
          organizationShortName || organizationName || taxCode || '',
        ],
        domId: 'businessYearsPieChartId',
        titleJpg: label,
      }}
      downloadCsv={{
        disabled: !Object.keys(data).length,
        downloadFunc: () =>
          exportBusinessYears({
            OrganizationId: params.organizationId,
          }),
      }}
    >
      {renderContent()}
    </Panel>
  )
}
